import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"tick\">\n<title>tick</title>\n<path d=\"M7.584 12.836l-5.877-5.877c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l6.667 6.667c0.421 0.421 1.116 0.383 1.488-0.083l10.667-13.333c0.345-0.431 0.275-1.061-0.156-1.406s-1.061-0.275-1.406 0.156l-9.969 12.461z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol